




















































































import storeHelper from "@/store/store-helper";
import { DocumentVersionInfo } from "@/types/document/documentVersionInfo";
import Vue from "vue";
import MarkAsFavoriteAction from "@/components/modules/document/toolbar/actions/MarkAsFavoriteAction.vue";
import AddCommentAction from "@/components/modules/document/toolbar/actions/AddCommentAction.vue";
import PrintDocumentAction from "@/components/modules/document/toolbar/actions/PrintDocumentAction.vue";
import ShowDocumentDetailsAction from "@/components/modules/document/toolbar/actions/ShowDocumentDetailsAction.vue";
import ShareMenuDocumentAction from "@/components/modules/document/toolbar/actions/ShareMenuDocumentAction.vue";
import MoreMenuDocumentActions from "@/components/modules/document/toolbar/actions/MoreMenuDocumentActions.vue";
import ZenyaDialog, { IZenyaDialog } from "@/components/dialogs/ZenyaDialog.vue";
import { CommentType, DocumentRoute, DocumentVersionState } from "@/enums";
import { DocumentAnchor, DocumentField } from "@infoland/iprova-api";
import { DocumentReviewer } from "@/types/document/documentReviewer";
export default Vue.extend({
    name: "DocumentToolbar",
    components: {
        MarkAsFavoriteAction,
        AddCommentAction,
        PrintDocumentAction,
        ShareMenuDocumentAction,
        MoreMenuDocumentActions,
        ShowDocumentDetailsAction,
        ZenyaDialog
    },
    props: {
        documentProperties: Object as () => DocumentVersionInfo,
        documentFields: Array as () => DocumentField[],
        isDocumentReady: Boolean,
        hasReviewInstructions: Boolean,
        documentRoute: String as () => DocumentRoute,
        shouldShowCommentsDrawer: Boolean,
        changesSincePreviousVersion: String,
        showChangesComparedToPrevious: Boolean,
        commentSubjectSelections: Array as () => DocumentAnchor[],
        commenterTypeForAddingComment: String as () => CommentType,
        userIsDocumentAdministrator: Boolean,
        reviewer: Object as () => DocumentReviewer
    },
    data: function () {
        return {
            route: { ...DocumentRoute },
            showSavePendingChangesDialog: false
        };
    },
    computed: {
        canGoBack(): boolean {
            return storeHelper.siteStore.canGoBack;
        },
        isMarkedAsFavorite(): boolean {
            if (this.documentProperties) return this.documentProperties.marked_as_favorite;
            else return false;
        },
        showCommentButton(): boolean {
            return this.documentRoute === DocumentRoute.PublishedDocument || this.documentRoute === DocumentRoute.ReadDocument;
        },
        mdAndUp(): boolean {
            return this.$vuetify.breakpoint.mdAndUp;
        },
        smAndUp(): boolean {
            return this.$vuetify.breakpoint.smAndUp;
        }
    },
    methods: {
        goBack(): void {
            if (
                this.documentProperties &&
                this.documentProperties.state == DocumentVersionState.Review &&
                storeHelper.pendingDocumentCommentStore.hasPendingItems(this.documentProperties.document_id)
            ) {
                (this.$refs.zenyadialog as Vue & IZenyaDialog)
                    .open(this.$t("document.review.pendingChangesDialog.dialogTitle"), this.$t("document.review.pendingChangesDialog.message"))
                    .then(confirmed => {
                        if (!confirmed) return;
                        storeHelper.pendingDocumentCommentStore.savePendingItems(this.documentProperties.document_id);
                        this.$router.go(-1);
                    });
            } else this.$router.go(-1);
        }
    }
});
